import { authenticate } from "./components/navigation/1_MsalAuth";

export const formatFileSize = (bytes, si=false, dp=1) => {
    const thresh = si ? 1000 : 1024;

    if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }

    const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] 
    let u = -1;
    const r = 10**dp;

    do {
        bytes /= thresh;
        ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

    return bytes.toFixed(dp) + ' ' + units[u];
}

export const formatISODatetime = (isoDatetimeString) => {
    const isoDatetime = new Date(isoDatetimeString);
    const offset = isoDatetime.getTimezoneOffset();
    const local = new Date(isoDatetime.getTime() - offset*60000);
    return local.toLocaleString() 
}

export const generateResponse = (userContext, setUserContext, addMessage, replaceMessage, documentid, conversationid, humanInput, queryContext, promptTemplate, retryCount) => {
    //THIS PROBABLY NO LONGER WORKS BUT IS CURRENTLY UNUSED
    document.getElementById('humanInputTextarea').disabled = true;
    document.getElementById('submitQueryButton').disabled = true;
    
    retryCount = retryCount || 0;
    if (retryCount === 0) {
        addMessage([{
            type: 'human',
            data: {
                content: humanInput,
                human_input: humanInput,
                additional_kwargs: {},
                type: 'human',
                example: false,
                created: new Date().toISOString().slice(0,-1)
            }
        },{
            type: 'ai',
            data: {
                content: 'PLACEHOLDER',
                additional_kwargs: {},
                type: 'ai',
                example: false,
                created: new Date().toISOString().slice(0,-1)
            }
        }]);
    }

    const apiGatewayInvokeUrl = process.env[`REACT_APP_API_GATEWAY_INVOKE_URL__${process.env["REACT_APP_DEPLOYMENT_TYPE"]}`]
    const endpoint = `${apiGatewayInvokeUrl}/${documentid}/${conversationid}`;
    const params = {
        method: "POST",
        headers: {
            "Authorization": `Bearer ${userContext.account.idToken}`
        },
        body: JSON.stringify({
            "model": userContext.model,
            "human_input": humanInput,
            "context": queryContext,
            "prompt_template": promptTemplate
        })
    };
    
    fetch(endpoint, params)
        .then(response => response.json())
        .then(responseJson => {
            generateConversationOverview(userContext, setUserContext, documentid, conversationid);
            document.getElementById('submitQueryButton').disabled = false;
            replaceMessage(responseJson);
            focusOnQueryInput();
        })
        .catch(e => {
            console.log('error', e);
            document.getElementById('submitQueryButton').disabled = false;
            //retryFetch({userContext, setAccount}, generateResponse, retryCount);
        });
}

export const generateConversationOverview = (userContext, setUserContext, documentid, conversationid) => {
    const apiGatewayInvokeUrl = process.env[`REACT_APP_API_GATEWAY_INVOKE_URL__${process.env["REACT_APP_DEPLOYMENT_TYPE"]}`]
    const endpoint = `${apiGatewayInvokeUrl}/doc/${documentid}/${conversationid}`;
    const params = {
        method: "PATCH",
        headers: {
            "Authorization": `Bearer ${userContext.account.idToken}`
        }
    };

    fetch(endpoint, params)
        .then(response => response.json())
        .then(responseJson => {
            const summarizedConversationId = responseJson.conversationid;
            const conversationSummary = responseJson.conversationSummary;

            const tempUserContext = {...userContext};
            for (const curConversationOverview of tempUserContext.document.conversations) {
                if (curConversationOverview.conversationid === summarizedConversationId) {
                    curConversationOverview.summary = conversationSummary;
                }
            }
            setUserContext(tempUserContext);
        })
        .catch(e => {
            console.log('error', e);
            //retryFetch({userContext, setAccount}, generateConversationOverview, retryCount);
        });
}

export const scrollToBottom = (scrollDelay, behavior) => {
    const messagesContainer = document.querySelector('.messages-container');
    if (messagesContainer) {
        setTimeout(() => {
            messagesContainer.scrollTo({top: 9999999, behavior:behavior || 'smooth'});
        }, scrollDelay || 200);
    } 
}

export const scrollToTop = (scrollDelay, behavior) => {
    const messagesContainer = document.querySelector('.messages-container');
    if (messagesContainer) {
        setTimeout(() => {
            messagesContainer.scrollTo({top: -9999999, behavior:behavior || 'instant'});
        }, scrollDelay || 200);
    }
}

export const focusOnQueryInput = (delay) => {
    setTimeout(() => {
        const queryInputElement = document.getElementById('humanInputTextarea');
        queryInputElement.value = '';
        queryInputElement.disabled = false;
        queryInputElement.setAttribute('style', `height:0px;overflow-y:hidden;`);
        queryInputElement.focus();
    }, delay || 0);
}

export const isAdmin = (username) => {
    const admins = process.env["REACT_APP_ADMINS"].split(',');
    return admins.indexOf(username) > -1;
}

export const convertToFloat = (str) => {
    const floatVal = parseFloat(str);
    if (isNaN(floatVal)) {
      return str;
    } else {
      return floatVal;
    }
}

export const retryFetch = (userContext, setAccount, retryCount, func, {...funcArgs}) => {
    console.log(`reauthenticating after failed ${func.name}() call`);
    authenticate({userContext, setAccount});

    if (++retryCount < 3) {
        setTimeout(() => {
            console.log(`trying ${func.name}() again`)
            func(retryCount, {...funcArgs});
        }, 1500); 
    } else {
        console.log(`could not complete ${func.name}() after multiple attempts`)
    }
}